module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/invoice@3x-90cf41bbe265a1c3632973d4ee78628a.png";